import React from 'react';
import { Link } from 'react-router-dom';
import './PublicSchool.css';
import './PublicGroupPage.css';

/**
 * ClosedSchoolNotice - public group/course page body when the school has switched class
 * management off (backend returns isOpen:false with no listings). Keeps the school's
 * branding header so the link is not dead, and states that new enrolments are closed.
 */
const ClosedSchoolNotice = ({ orgSlug, orgName, branding }) => {
    const b = branding || {};
    const headerColor = b.headerColor || 'var(--dl-color-purple-default)';
    const headerTextColor = b.headerTextColor || 'var(--dl-color-gray-white)';

    return (
        <div className="public-school" style={{ background: b.backgroundColor, color: b.textColor }}>
            <div className="public-school-header public-school-header--detail" style={{ background: headerColor }}>
                <Link to={`/school/${orgSlug}`} className="public-group-back-link" style={{ color: headerTextColor, opacity: 0.75 }}>
                    {orgName || 'School'}
                </Link>
            </div>
            <div className="public-school-body">
                <div className="public-school-term-notice" style={{ borderColor: headerColor }}>
                    <p className="public-school-term-notice-title" style={{ color: headerColor }}>
                        {orgName || 'This school'} isn't taking new enrolments online right now
                    </p>
                    <p className="public-school-term-notice-text">Please check back soon.</p>
                </div>
            </div>
            <p className="public-school-powered-by">Powered by Dance Localé</p>
        </div>
    );
};

export default ClosedSchoolNotice;
